import { Box, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ModalStatisticsTabs({ tabsValue, setTabsValue }) {
  // console.log("Tabs value in ModalStatisticsTabs", tabsValue);

  const { t } = useTranslation("statisticsTabs");

  const handleTabsChange = (e, newValue) => {
    setTabsValue(newValue);
  };
  return (
    <Box sx={{ display: "flex" }}>
      <Tabs
        value={tabsValue}
        onChange={handleTabsChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        <Tab sx={{ fontSize: "medium" }} label={t("physicalActivity")} />
        <Tab sx={{ fontSize: "medium" }} label={t("exercise")}  />
        <Tab sx={{ fontSize: "medium" }} label={t("sleep")}  />
        <Tab sx={{ fontSize: "medium" }} label={t("liquids")} />
        <Tab sx={{ fontSize: "medium" }} label={t("heartRate")} />
        <Tab sx={{ fontSize: "medium" }} label={t("nutrition")}  />
        <Tab sx={{ fontSize: "medium" }} label={t("weight")}  />
        <Tab sx={{ fontSize: "medium" }} label={t("risk")}  />
        <Tab sx={{ fontSize: "medium" }} label={t("questionnaires")}  />
        <Tab sx={{ fontSize: "medium" }} label={t("recommendations")}  />
      </Tabs>
    </Box>
  );
}
